<template>
  <div class="app-container" style="background-color: #f5f6f8; font-size: 14px;">
    <van-nav-bar title="缴费信息" left-arrow @click-left="$router.push('/home')"
                 :right-text="year" @click-right="showDate = true"
    />
    <div class="van-address-edit">
      <van-row v-if="loading">
        <van-col :span="24" style="text-align: center;">
          <van-loading size="24px">加载中...</van-loading>
        </van-col>
      </van-row>
      <div class="van-address-edit__fields" v-else>
        <template v-for="row in data" v-if="data.length > 0">
          <div style="margin-top: 20px; border-radius: 8px; overflow: hidden;">
            <van-panel :key="row.id">
              <div style="padding: 10px 10px;">
                支付方式：{{ row.charge_name }}
              </div>
              <template #header>
                <van-row style="padding: 10px 10px;">
                  <van-col :span="17">
                    <span style="font-size: 18px; font-weight: bold;">
                      信息技术服务费
                    </span>
                  </van-col>
                  <van-col :span="7" style="text-align: right">
                    <span class="price">
                      ￥{{ row.amount | toThousandFilter }}
                    </span>
                  </van-col>
                </van-row>
              </template>
              <template #footer>
                <van-row>
                  <van-col :span="2">
                    <van-icon name="clock" class="list-clock" />&nbsp;
                  </van-col>
                  <van-col :span="17">
                    <span>
                      {{ row.cost_date }}
                    </span>
                  </van-col>
                  <van-col :span="5" style="text-align: right;">
                    <van-tag plain type="success">已支付</van-tag>
                  </van-col>
                </van-row>
              </template>
            </van-panel>
          </div>
          <van-row>
            <van-col :span="24" style="color: #ccc; margin-top: 40px; text-align: center;">
              &nbsp;
            </van-col>
          </van-row>
        </template>
        <template v-if="data.length === 0">
          <van-row>
            <van-col :span="24" style="text-align: center;">
              <span>暂无数据</span>
            </van-col>
          </van-row>
        </template>
      </div>
    </div>
    <change-year :show="showDate" @change="onYearChange" />
  </div>
</template>

<script>
import ChangeYear from '../commons/change-year'
import { getCostList } from '@/api/cost'
export default {
  components: { ChangeYear },
  data() {
    return {
      data: [],
      loading: false,
      showDate: false,
      year: new Date().getFullYear() + ' 年',

      queryCondition: {
        total: this.CONST.PAGINATION.TOTAL,
        page: this.CONST.PAGINATION.PAGE,
        rows: this.CONST.PAGINATION.MAX_ROWS,
        sort: 'cost_date',
        order: 'desc',
        wx_view: this.CONST.YES_NO.find(status => status.name === '是').id,
        begin_cost_date: null,
        end_cost_date: null,
        client_id: this.$store.getters.currClient.client_id
      }
    }
  },
  mounted() {
    const year = new Date().getFullYear()
    this.queryCondition.begin_cost_date = year + '-01-01'
    this.queryCondition.end_cost_date = year + '-12-31'
    this.query()
  },
  methods: {
    onYearChange(show, year) {
      this.showDate = show
      if (year) {
        this.year = year.name
        this.queryCondition.begin_cost_date = year.value + '-01-01'
        this.queryCondition.end_cost_date = year.value + '-12-31'
        this.query()
      }
    },
    query(page) {
      this.loading = true
      if (page) {
        this.queryCondition.page = page
      }
      this.data = []
      getCostList(this.queryCondition).then(resp => {
        this.data = resp.rows || []
        this.loading = false
      }).catch(resp => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
  .list-clock {
    color: skyblue;
    font-size: 18px;
  }
  .price {
    color: darkorange;
    font-size: 18px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/payment.vue